import { type Content, Portal, Root, Trigger } from '@radix-ui/react-hover-card'
import { type ComponentPropsWithoutRef, type ElementRef, forwardRef } from 'react'
import React from 'react'

import type { Size, Width } from '../../../themes/types'
import { StyledArrow, StyledContent } from './HoverCard.styles'

const HoverCard = ({ openDelay = 250, ...props }: ComponentPropsWithoutRef<typeof Root>) => (
  <Root openDelay={openDelay} {...props} />
)

const HoverCardTrigger = Trigger

export type HoverCardContentProps = ComponentPropsWithoutRef<typeof Content> & {
  'data-e2e'?: string
  spacing?: Size
  minWidth?: Width
}

const HoverCardContent = forwardRef<ElementRef<typeof Content>, HoverCardContentProps>(
  (
    {
      children,
      'data-e2e': dataE2e,
      sideOffset = 4,
      spacing = 'small',
      minWidth = '250px',
      ...props
    },
    ref
  ) => (
    <Portal>
      <StyledContent
        $spacing={spacing}
        $minWidth={minWidth}
        data-e2e={dataE2e}
        ref={ref}
        sideOffset={sideOffset}
        {...props}
      >
        <StyledArrow />

        {children}
      </StyledContent>
    </Portal>
  )
)

export { HoverCard, HoverCardTrigger, HoverCardContent }
